const LOGIN_PAGE = ":login-page";
const LOGIN_MFA_PAGE = ":login:mfa-page";
const LOGIN_UPDATE_PROFILE_PAGE = ":login:update-profile-page";
const ACCOUNT_LOCKED_PAGE = ":account-locked-page";
const DEFAULT_ERROR_PAGE = ":default-error-page";

// in registration, datalayer is turned on for all appid's
const defaultFalgs = {
  local: true,
  test: true,
  dev: true,
  uat: true,
  prod: true,
};

const datalayerDisabled = {
  local: false,
  test: false,
  dev: false,
  uat: false,
  prod: false,
};

const activeAdobeAppsObj = {
  2320147: datalayerDisabled, // dtc
  266976: defaultFalgs, // ltc
  362772: defaultFalgs, // life
  27096999: defaultFalgs, // vitality
  10597976: datalayerDisabled, // multilife
  362773: defaultFalgs, // pdco
  DEFAULT: datalayerDisabled, // any other appids will be using this datalayerDisabled
};

// currently we are using only one url for all appid's. Adding below object for future proof.
// So that we may get multiple urls for different appids
const adobeUrlsObj = {
  27096999: process.env.REACT_APP_ADOBE_SCRIPT_URL, // vitality
  DEFAULT: process.env.REACT_APP_ADOBE_SCRIPT_URL, // for all other appids
};

const pageNamesObj = {
  2320147: "DTC",
  266976: "LTC",
  362772: "LIFE",
  27096999: "insurance:vitality:johnhancockinsurance", // vitality
  10597976: "MultiLife",
  362773: "PDCO",
  DEFAULT: "",
};

// we are not using this currently. Just added for future references
const pageSubSectionNameObj = {
  1104: {
    login: LOGIN_PAGE,
    loginMfa: LOGIN_MFA_PAGE,
    loginUpdateProfile: LOGIN_UPDATE_PROFILE_PAGE,
    accountLocked: ACCOUNT_LOCKED_PAGE,
    defaultError: DEFAULT_ERROR_PAGE,
  },
  27096999: {
    accountLocked: ACCOUNT_LOCKED_PAGE,
    defaultError: DEFAULT_ERROR_PAGE,
  },
  DEFAULT: {},
};

const adobePageNamesSuffixObj = {
  step1: "Registration - Your Information",
  step2: "Create Password",
  step3: "Verify MFA",
  accountAlreadyExists: "Account Alread Exists",
  unverifiedUser: "Verification Policy",
  registrationComplete: "Registration Complete",
};

const handler = {
  get: (objArg, key) => objArg[key] || objArg.DEFAULT,
};

export const adobeActiveApps = new Proxy(activeAdobeAppsObj, handler);
export const adobeUrls = new Proxy(adobeUrlsObj, handler);
export const adobePageNames = new Proxy(pageNamesObj, handler);
export const adobePageNamesSuffix = adobePageNamesSuffixObj;
export const pageSubSectionName = new Proxy(pageSubSectionNameObj, handler); // we are not using this currently
